<template>
  <section
    class="how-to-play pos-relative pt-400 pb-200 px-300 x-large:py-300 xx-large:pb-600"
    aria-labelledby="h2_how-to-play"
  >
    <div class="dot-block" aria-hidden="true"></div>
    <div class="container pos-relative">
      <div id="howToPlay" class="section-anchor" aria-hidden="true"></div>
      <div
        class="how-to-play__content xx-large:d-flex xx-large:align-items-center"
      >
        <div class="how-to-play__details x-large:flex-item-1">
          <div
            class="how-to-play__title section-heading mb-400 x-large:mb-600"
            id="h2_how-to-play"
          >
            <span>How to Play</span><br />
            <span class="text-default">the Fan Exam</span>
          </div>
          <ul class="how-to-play__list reset-list">
            <li
              class="how-to-play__list-item mb-300 x-large:mb-600 d-flex align-items-center"
              v-for="(item, index) in how_to_play"
              :key="index"
            >
              <span
                v-if="item.icon != 'rose'"
                :class="
                  'sf-' +
                    item.icon +
                    ' how-to-play__list-icon mr-150 x-large:mr-600'
                "
                aria-hidden="true"
              ></span>
              <span
                v-else
                aria-hidden="true"
                class="how-to-play__content_item mr-150 x-large:mr-600"
              >
              </span>
              <div
                class="how-to-play__list-text font-style-italic flex-item-1"
                v-html="item.text"
              ></div>
            </li>
          </ul>
        </div>
        <div class="how-to-play__image text-align-center">
          <img class="d-inline-block" src="@/assets/how_to_play_2021.png" alt="" />
        </div>
      </div>
      <div class="text-align-center my-200">
        <span class="how-to-play__footer-text font-weight-600 text-transform-uppercase"
          >The more you play, the more chances you have to win!</span
        >
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HowToPlay",
  props: ["how_to_play"],
};
</script>

<style lang="scss">
.how-to-play {
  &__title {
    font-size: 1.5rem;
  }

  &__content_item {
    display: inline-block;
    background-image: url("../assets/Black_Rose.png");
    background-repeat: no-repeat;
    background-size: contain;
  }

  &__list {
    &-icon {
      font-size: 36px;
    }
    &-text {
      font-size: 0.875rem;
      line-height: 1.5;
    }

    &-item:last-child {
      span {
        width: 50px;
        height: 45px;
      }
    }
  }

  .dot-block {
    bottom: 0;
    left: 0;
    opacity: 0.95;
    width: 182px;
    height: 100%;
  }

  @media screen and (min-width: 768px) {
    &__title {
      font-size: 3rem;
    }

    &__list {
      &-text {
        font-size: 1rem;
      }
    }

    .dot-block {
      width: 250px;
    }
  }

  @media screen and (min-width: 1024px) {
    .dot-block {
      width: 469px;
    }
    &__footer-text {
      font-size: 1.125rem;
    }
  }
}
</style>
